
import RouterIndex from "./Router/index";
import Banner from "./Components/Img.Carousel";

function App() {
  return (
    <div className="App">
      <Banner></Banner>
      <RouterIndex></RouterIndex>
    </div>
  );
}

export default App;
